var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "VPopup",
    {
      staticClass: "rbvp-settings-popup be-settings-extra-options",
      attrs: {
        open: _vm.popupOpen,
        fixed: "",
        "auto-destroy": "",
        "trigger-element": _vm.triggerElement,
      },
      on: { "popup-change": _vm.handlePopupChange },
    },
    [
      _c("div", { staticClass: "rbvp-settings" }, [
        _c("div", { staticClass: "rbvp-settings-header" }, [
          _c(
            "div",
            { staticClass: "rbvp-settings-title" },
            [
              _c("VIcon", { attrs: { icon: "mdi-tune", size: 18 } }),
              _vm._v("\n        RBVP 设置\n      "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "rbvp-settings-close",
              attrs: { title: "关闭" },
              on: {
                click: function ($event) {
                  return _vm.requestClosePopup()
                },
              },
            },
            [_c("VIcon", { attrs: { size: 18, icon: "close" } })],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "rbvp-settings-content" }, [
          _c("div", { staticClass: "rbvp-tabs" }, [
            _c(
              "button",
              {
                staticClass: "rbvp-tab",
                class: { active: _vm.selectedTab === "rules" },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.selectedTab = "rules"
                  },
                },
              },
              [
                _c("VIcon", {
                  attrs: { icon: "mdi-file-document-edit-outline", size: 18 },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "rbvp-tab-label" }, [_vm._v("规则")]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "rbvp-tab",
                class: { active: _vm.selectedTab === "ruleSets" },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.selectedTab = "ruleSets"
                  },
                },
              },
              [
                _c("VIcon", {
                  attrs: { icon: "mdi-folder-cog-outline", size: 18 },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "rbvp-tab-label" }, [
                  _vm._v("规则集"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "rbvp-tab",
                class: { active: _vm.selectedTab === "namespaces" },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.selectedTab = "namespaces"
                  },
                },
              },
              [
                _c("VIcon", { attrs: { icon: "mdi-lan-connect", size: 18 } }),
                _vm._v(" "),
                _c("span", { staticClass: "rbvp-tab-label" }, [
                  _vm._v("命名空间"),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "rbvp-section" },
            [
              _vm.selectedTab === "rules"
                ? _c("RBVPRulesTab", {
                    attrs: {
                      state: _vm.rulesTabState,
                      actions: _vm.rulesTabActions,
                    },
                  })
                : _vm.selectedTab === "namespaces"
                ? _c("RBVPNamespacesTab", {
                    attrs: {
                      state: _vm.namespacesTabState,
                      actions: _vm.namespacesTabActions,
                    },
                  })
                : _c("RBVPRuleSetsTab", {
                    attrs: { state: _vm.ruleSetsTabState },
                  }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }